<template>
    <div>
        <tsoft-table
            name="agent-settlement"
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :additionalGetParameter="additionalGetParameter"
            :isNeedCreate="isNeedCreate && !isAgent && !isClient"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Операции взаиморасчетов по заданному фильтру отсутствуют. Попробуйте снова.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right-create-or-edit-agent-settlement"
            right
            backdrop
            shadow
            width="65em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <AgentSettlementProfile 
                    :agent_settlement="editedItem" 
                    @closed="isSidebarOpen=false"
                    @updated="profileUpdated"
                />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import {API_AGENT_SETTLEMENTS} from "@/constants";
    import AgentSettlementProfile from "@/components/agentSettlements/AgentSettlementProfile";

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem
    } from '@/mixins';

    const initialEditedItem = () => ({
        id: null,
        agent_company_id: null,
        title: '',
        description: '',
        amount: 0,
        operation_type: 'debit',
        status: 'pending',
        order_id: null,
        creator_user_id: null,
        approver_user_id: null,
        settlement_type: 'other',
        metadata: {},
        approved_at: null,
        completed_at: null,
        agent_company: {},
        order: {},
        creator: {},
        approver: {}
    })

    export default {
        components: {
            AgentSettlementProfile
        },    
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionDeleteItem,
            actionCreateOrUpdateItem
        ],
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &agent_company_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: agentSettlements
        },
        data() {
            return {
                loading: false,
                tableApiUrl: API_AGENT_SETTLEMENTS,
                componentRefreshKey: 0,
                dataOverlay: false
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),

            isAgent() {
                return this.currentUser.role.includes('agent');
            },

            isClient() {
                return this.currentUser.role.includes('client');
            },
        },
        watch: {
        },
        mounted() {
            this.editedItem = initialEditedItem();
            this.initialAssign();
        },
        methods: {
            initialAssign() {
                // Инициализация данных
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem();
                this.initialAssign();
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            profileUpdated(data) {
                // If editIndex > -1 → update existing row; else → prepend new row
                if (this.editIndex > -1 && this.items && this.items.data && this.items.data[this.editIndex]) {
                    Object.assign(this.items.data[this.editIndex], data);
                } else if (this.items && this.items.data) {
                    this.items.data.unshift(data);
                }

                // Close sidebar and reset state
                this.onCreatedOrUpdatedCallback();
                this.editIndex = -1;
                this.validationErrors = '';
                this.makeToast('success');
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            modalTitle() {
                let title = 'Добавление операции взаиморасчета'
                if (this.editIndex > -1) {
                    title = 'Редактирование операции взаиморасчета #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            }
        }
    }
</script> 